<div class="ui-g">
  <div class="cardGray ui-g-12 ui-md-8 ui-lg-6" style="margin: 3% auto;">
      <div class="ui-g" >
          <img style="margin:auto; width: 80px;" src="assets/images/register/register.png">
       </div>
      <div style="text-align: center;">
          <h2 class="title">Formulario de registro</h2>
          <p class="subTitle" >Ingrese los siguientes datos:</p>
      </div>
      <p-toast ></p-toast>
      <div class="ui-g-12">
        <!--<p-messages></p-messages>-->
          <div class="ui-g-12 form-group">
            <form class="form-group-login"  [formGroup]="userform" (ngSubmit)="onSubmit(userform.value)">
              <div class="ui-g-12">
                  <h4 class="textinput">Correo electrónico</h4>
                  <input formControlName="email" id="float-input-email" type="email" size="40"  pInputText >
                  <p-message severity="error" text="correo electrónico es requerido" *ngIf="!userform.controls['email'].valid&&userform.controls['email'].dirty"></p-message>
              </div>
              <div class="ui-g-12">
                  <h4 class="textinput">Número de teléfono</h4>
                  <div class="ui-g-12 p-grid" style="padding: 0;">
                    <div class="ui-g-12 ui-md-4 ui-lg-4">
                      <p-dropdown [options]="items" formControlName="country"  placeholder="{{countryTitle}}" optionLabel="idCode" [showClear]="true" [virtualScroll]="false" [itemSize]="31" [filter]="false"></p-dropdown>
                      <p-message severity="error" text="seleccione país" *ngIf="!userform.controls['country'].valid&&userform.controls['country'].dirty"></p-message>
                    </div>
                    <div class="ui-g-12 ui-md-8 ui-lg-8">
                      <input id="float-input" type="tel" size="10"  pInputText formControlName="phoneNumber" >
                      <p-message severity="error" text="número de teléfono es requerido" *ngIf="!userform.controls['phoneNumber'].valid&&userform.controls['phoneNumber'].dirty"></p-message>
                    </div>
                  </div>
              </div>
              <div class="ui-g-12">
                  <h4 class="textinput">Documento de identificación</h4>
                  <input id="float-input-dpi" type="number" size="30"  pInputText formControlName="dpi" >
                  <p-message severity="error" text="dpi es requerido" *ngIf="!userform.controls['dpi'].valid&&userform.controls['dpi'].dirty"></p-message>
              </div>
              <div class="ui-g-12">
                  <button class="ui-button-primary" pButton type="submit" label="{{loginBtnTitle}}" [disabled]="!userform.valid" style="width:100%; margin-top: 20px;"></button>
                 <!--
                  <h5>Message Service</h5>
                  <button type="button" pButton (click)="showViaService()" label="Via Service"></button>
                  -->
              </div>
            </form>
          </div>
      </div> 
  </div>
</div>

<!--div class="content-section implementation ui.fluid" id="mainContainer">
  <p-toolbar class="ui.fluid" >
    <div class="ui-toolbar-group-left">
      <button pButton type="button" icon="pi pi-question" class="ui-button-success"></button>
    </div>
    <div class="ui-toolbar-group-right">
      <button pButton type="button" icon="pi pi-question" class="ui-button-success"></button>
    </div>
    <div class="ui.fluid" style="display: flex;" >
      <img  class="logo" src='https://firebasestorage.googleapis.com/v0/b/atlantida-fc6a9.appspot.com/o/webImages%2Ficon_atlantida.png?alt=media&token=76271395-253a-477c-80b1-09054fc749bf'>
    </div>
  </p-toolbar>

  <form class="form-group-login"  [formGroup]="userform" (ngSubmit)="onSubmit(userform.value)">
    <p-toast ></p-toast>
    <h1  class="title-login" style="text-align: center;">REGISTRO</h1>
    <h1  class="title-login" style="text-align: center;">{{fcmToken}}</h1>
    <div class="ui-grid ui-grid-responsive ui-grid-pad ui-fluid" style="margin: 10px 0">
      <div class="ui-grid-row item-login">
        <div class="ui-grid-col-5">
          <p-dropdown [options]="items" formControlName="country"  placeholder="{{countryTitle}}" optionLabel="idCode" [showClear]="true" [virtualScroll]="false" [itemSize]="31" [filter]="false"></p-dropdown>
          <p-message severity="error" text="country es requerido" *ngIf="!userform.controls['country'].valid&&userform.controls['country'].dirty"></p-message>
        </div>
        <div class="ui-grid-col-12">
                    <span class="ui-float-label">
                        <input id="float-input" type="tel" size="10"  pInputText formControlName="phoneNumber" >
                        <label for="float-input">{{phoneTitle}}</label>
                    </span>
          <p-message severity="error" text="phoneNumber requerido" *ngIf="!userform.controls['phoneNumber'].valid&&userform.controls['phoneNumber'].dirty"></p-message>
        </div>
      </div>
      <div class="ui-grid-row item-login">
        <div class="ui-grid-col-12">
                    <span class="ui-float-label">
                        <input formControlName="email" id="float-input-email" type="email" size="40"  pInputText >
                        <label for="float-input-email">{{emailTitle}}</label>
                    </span>
          <p-message severity="error" text="email requerido" *ngIf="!userform.controls['email'].valid&&userform.controls['email'].dirty"></p-message>
        </div>
      </div>
      <div class="ui-grid-row item-login">
        <div class="ui-grid-col-12">
                    <span class="ui-float-label">
                        <input id="float-input-dpi" type="number" size="30"  pInputText formControlName="dpi" >
                        <label for="float-input-dpi">{{dpiTitle}}</label>
                    </span>
          <p-message severity="error" text="dpi requerido" *ngIf="!userform.controls['dpi'].valid&&userform.controls['dpi'].dirty"></p-message>
        </div>

      </div>


      <div class="ui-grid-row item-login">
        <div class="ui-grid-col-12">
          <button pButton type="submit" label={{loginBtnTitle}} [disabled]="!userform.valid"></button>
        </div>
      </div>
      <div style="text-align:center;margin-top:20px" *ngIf="submitted">
        Form Submitted
        <br>
      </div>
    </div>
  </form>
  <div class="ui-grid-col-12">
    <button pButton label={{loginBtnTitle}} (click)="setvalues()"></button>
  </div>
</div-->
